// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"EmptyState_wrapper__gyaOa","icon":"EmptyState_icon__XIijG","button":"EmptyState_button__kuM8X"};